import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { AboutComponent } from './components/about/about.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { EproComponent } from './components/epro/epro.component';
import { ContactComponent } from './components/contact/contact.component';
import { ContactFormComponent } from './components/contact/contact-form/contact-form.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { DefaultContactPageComponent } from './components/default-contact-page/default-contact-page.component';
import { PricingExempleComponent } from './components/pricing/pricing-exemple/pricing-exemple.component'
import { WelcomeComponent } from './components/welcome/welcome.component';
import { PartnershipComponent } from './components/pricing/partnership/partnership.component';
import { WrongRouteComponent } from './components/wrong-route/wrong-route.component';
const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent, data: { state: 'home' } },
  { path: 'about', component: AboutComponent, data: { state: 'about' } },
  { path: 'pricing', component: PricingComponent, data: { state: 'pricing' } },
  { path: 'pricing/pricing-form', component: PricingExempleComponent, data: { state: 'pricing/pricing-exemple' } },
  { path: 'contact/contact-form', component: ContactFormComponent, data: { state: 'contact/contact-form' } },
  { path: 'epro', component: EproComponent, data: { state: 'epro' } },
  { path: 'contact', component: ContactComponent, data: { state: 'contact' } },
  { path: 'privacy-policy', component: PrivacyPolicyComponent, data: { state: 'privacicy-policy' } },
  { path: 'contact-form', component: DefaultContactPageComponent, data: { state: 'contact-form' } },
  { path: 'welcome', component: WelcomeComponent, data: { state: 'welcome' }},
  { path: 'partnership', component: PartnershipComponent, data: { state: 'partnership' } },
  { path: '**', pathMatch   : 'full', component : WrongRouteComponent, data: {title: 'Page Not Found'} }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
  useHash: true;
}
